/* Copyright (c) 2024 Xperi. All Rights Reserved. */

import React, { FunctionComponent, useEffect, useState } from 'react';

import { DebugScreenController } from 'src/core/debugscreen/DebugScreenController';

import ConsoleLog from './ConsoleLog';
import NetworkStats from './NetworkStats';
import StreamStats from './StreamStats';
import SystemInfo from './SystemInfo';

import './DebugScreen.scss';

const DebugScreen: FunctionComponent = (): JSX.Element => {
    const networkAndStreamStatsHeaderText = 'Network and Stream Stats';

    const [isEnabled, setIsEnabled] = useState(
        DebugScreenController.getInstance().isScreenEnabled() || false,
    );

    const toggleDebugScreenDisplay = () => {
        setIsEnabled((state) => !state);
    };

    useEffect(() => {
        DebugScreenController.getInstance()
            .getToggleScreenListener()
            .subscribe(toggleDebugScreenDisplay);
        return () => {
            DebugScreenController.getInstance()
                .getToggleScreenListener()
                .cancel(toggleDebugScreenDisplay);
        };
    }, []);

    return isEnabled ? (
        <div className="debug-screen">
            <div className="network-and-stream-stats-container">
                <div className="network-and-stream-stats-heading">
                    {networkAndStreamStatsHeaderText}
                </div>
                <NetworkStats />
                <StreamStats />
            </div>
            <ConsoleLog />
            <SystemInfo />
        </div>
    ) : (
        <></>
    );
};

export default DebugScreen;
